module.exports = __webpack_public_path__ + "static/media/FilsanPic.22f36a87.gif";